import {
  USER_LIMITS_GET,
  USER_LIMITS_GET_SUCCESS,
  USER_LIMITS_GET_ERROR,
  USER_LIMITS_UPDATE_CREDITS,
  USER_LIMITS_RESET_CREDITS,
} from './type'

/**
 *
 * @param {*} callback
 */
export const userLimitsGetAction = callback => {
  return {
    type: USER_LIMITS_GET,
    payload: { callback },
  }
}

/**
 *
 * @param {*} response
 */
export const userLimitsGetSuccess = response => {
  return {
    type: USER_LIMITS_GET_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const userLimitsGetError = () => {
  return {
    type: USER_LIMITS_GET_ERROR,
  }
}

/**
 *
 * @param {number} creditsToSpend - Number of credits to spend
 */
export const userLimitsUpdateCredits = amount => {
  return {
    type: USER_LIMITS_UPDATE_CREDITS,
    payload: { amount },
  }
}
